module.exports = __webpack_public_path__ + "static/img/1_1.043f65c2.jpg";